export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwo_rg_p.30f21bc7.jpg";